import axios from "axios";
import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import Translate from "react-translate-component";
import SectionHeadline from "../../../../UI/SectionHeadline/SectionHeadline";
import "../News/News.scss";
import NewsItem from "./NewsItem/NewsItem";

class News extends React.Component {
  _isMounted = false;

  state = {
    isToggled: false,
    news: [],
  };

  componentDidMount() {
    this._isMounted = true;
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/rest/news`)
      .then((res) => {
        if (this._isMounted) {
          const news = res.data.items;
          this.setState({ news });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <section id={this.props.scrollAnchor} className="News">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
                <SectionHeadline className="dark mt-4">
                  <Translate content="homepage.news.headline" />
                </SectionHeadline>
              </ScrollAnimation>
            </div>
            <div className="news_space_placeholder">
              {this.state.news.slice(0, 3).map((item) => {
                return (
                  <NewsItem
                    key={item.id}
                    id={item.id}
                    externalUrl={item.externalUrl}
                    headline={item.title}
                    text={item.description}
                    img={item.headingImageURL}
                    date={item.publishedAt}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default News;
